module.exports = __webpack_public_path__ + "static/coindesk-fa5f697b784c71d756b02f28d852e035.svg";